import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, border, mediaQuery } = baseVariables;

export const StyledResubmitRfp = styled.div``;

export const StyledResubmitRfpForm = styled.div`
  padding: ${toRem(40)} ${toRem(16)};
  border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
  background-color: ${color.base20};
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  @media ${mediaQuery.md} {
    padding: ${toRem(40)} ${toRem(60)};
    border-radius: ${toRem(12)};
  }

  @media ${mediaQuery.lg} {
    padding: ${toRem(40)} ${toRem(94)};
  }
`;
